import { graphql } from "gql.tada";

export const StillWatchingTitleSectionFragment = graphql(`
  fragment StillWatchingTitleSectionFragment on TitleSection {
    _id
    title
  }
`);
